import moment from 'moment'

export const formatDate = function(date: string): string {
  return moment
    .utc(date)
    .local()
    .format('DD.MM.YY, HH:mm:ss')
}
